import { Component, Input, OnDestroy } from "@angular/core";
import { AuthService } from "app/core/auth/service/auth.service";
import { Subject } from "rxjs";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";
import { MatIconButton } from "@angular/material/button";

@Component({
  selector: "logout-button",
  templateUrl: "./logout-button.component.html",
  imports: [SvgComponent, MatIconButton],
})
export class LogoutButtonComponent implements OnDestroy {
  @Input() public e2e: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private authService: AuthService) {}

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public logout(): void {
    this.authService.logout(true);
  }
}
